import { render, staticRenderFns } from "./LegalCorporateStep2.vue?vue&type=template&id=7b2a18d8&scoped=true&"
import script from "./LegalCorporateStep2.vue?vue&type=script&lang=js&"
export * from "./LegalCorporateStep2.vue?vue&type=script&lang=js&"
import style0 from "./LegalCorporateStep2.vue?vue&type=style&index=0&id=7b2a18d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2a18d8",
  null
  
)

export default component.exports